<template>
  <div class="resource-library">
    <div class="resource-library__collapse-area">
      <button
        class="mx-auto mb-2 block border-0 bg-transparent p-0 text-[13px] font-medium text-[#a5a5a5] transition hover:text-white focus:outline-none"
        data-entity="producer-expand-resourceLibrary"
        data-test="producer-assetLibrary-expandPanel"
        @click="$emit('expand')"
      >
        <span
          class="fas fa-angle-double-right text-[12px] leading-none"
          :class="{ 'fa-flip-horizontal': !collapsed }"
        />
      </button>

      <p class="resource-library__title">Libraries</p>
    </div>


    <div
      class="resource-library-body"
      :class="{
        'overflow-hidden': collapsed,
      }"
    >
      <splitter
        v-model="splitterHeights"
        class="h-full"
        vertical
      >
          <splitter-panel :min-height="40">
            <div class="flex h-full flex-col">
              <div class="resource-library-body__title-bar">
                <div class="flex min-w-0 items-center">
                  <button
                    class="ml-1 mr-1 inline-flex h-6 w-6 flex-shrink-0 items-center justify-center border-0 bg-transparent p-0 text-[1.2rem] font-medium text-[#a5a5a5] transition hover:text-white focus:outline-none"
                    data-entity="producer-expand-timeline"
                    data-test="producer-displayElements-expand"
                    @click="collapsedElements = !collapsedElements"
                  >
                    <span
                      class="fas fa-angle-double-up block text-[12px] leading-none"
                      :class="{ 'fa-flip-vertical': !collapsedElements }"
                    />
                  </button>

                  <div
                    :class="{
                      'source-types source-types--library': true,
                      'small-viewport': libraryTabOverflow,
                    }"
                    ref="libraryTabs"
                    @scroll="handleScroll('libraryTabs', $event)"
                  >
                    <button
                      v-if="libraryTabOverflow && showLibraryTabOverflowButton[0]"
                      class="small-viewport__button-left border-0 bg-transparent"
                      title="Scroll left"
                      data-test="producer-assets-libraryTabs-scrollLeft"
                      @click="scrollMenuLeft"
                    >
                      <span class="fas fa-angle-left" />
                    </button>

          <button
            :class="{
              btn: true,
              active: libraryTab === 'shows',
            }"
            data-test="producer-assets-showsTab"
            @click="libraryTab = 'shows'"
          >
            Shows
          </button>

                    <button
                      :class="{
                        btn: true,
                        active: libraryTab === 'content',
                      }"
                      data-test="producer-assets-assetsTab"
                      @click="libraryTab = 'content'"
                    >
                      {{ useGlobalSearch ? 'Graphics' : 'Asset Library' }}
                    </button>

                    <button
                      :class="{
                        btn: true,
                        active: libraryTab === 'design',
                      }"
                      data-test="producer-assets-designTab"
                      @click="libraryTab = 'design'"
                    >
                      {{ useGlobalSearch ? 'Media' : 'Design Library' }}
                    </button>

                    <button
                      v-if="libraryTabOverflow && showLibraryTabOverflowButton[1]"
                      class="small-viewport__button-right border-0 bg-transparent"
                      title="Scroll right"
                      data-test="producer-assets-libraryTabs-scrollRight"
                      @click="scrollMenuRight"
                    >
                      <span class="fas fa-angle-right" />
                    </button>
                  </div>
                </div>

                <div class="resource-library-body__controls">
                  <button
                    class="border-0 bg-transparent p-0 text-[#a5a5a5] transition hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 mr-4"
                    title="Refresh asset library"
                    data-entity="producer-assets-reloadAll"
                    data-test="producer-assets-reloadAll"
                    @click="reloadAssetLibrary"
                  >
                    <span class="fas fa-redo" />
                  </button>
                </div>
              </div>

              <!-- Shows Library -->
              <show-list
                v-if="libraryTab === 'shows'"
                ref="showList"
                class="flex-1 min-h-0"
              />

              <!-- New, shiny global search -->
              <global-search
                v-else-if="libraryTab === 'content' && useGlobalSearch"
                v-show="splitterHeights[0] > 0"
                ref="globalSearch"
              />

              <!-- Old, legacy assets tab -->
              <div v-else-if="libraryTab === 'content'" v-show="splitterHeights[0] > 0" class="flex flex-1 min-h-0 flex-col resource-library-body__panel">
              <div class="source-types-wrapper">
                <div
                  class="source-types"
                  :class="{
                    'small-viewport': elementTabOverflow,
                  }"
                  ref="elementTabs"
                  @scroll="handleScroll('elementTabs', $event)"
                >
                  <button
                    v-if="elementTabOverflow && showElementTabOverFlowButton[0]"
                    class="small-viewport__button-left border-0 bg-transparent"
                    title="Scroll left"
                    data-entity="producer-assets-scrollRight"
                    data-test="producer-assets-elementTabs-scrollLeft"
                    @click="scrollMenuLeft"
                  >
                    <span class="fas fa-angle-left" />
                  </button>

                  <button
                    :class="{
                      'tab-btn tab-btn--outlined': true,
                      active: elementTab === 'graphics',
                    }"
                    data-entity="producer-assets-showGraphics"
                    data-test="producer-assets-graphicsTab"
                    @click="elementTab = 'graphics'"
                  >
                    Custom
                  </button>

                  <button
                    :class="{
                      'tab-btn tab-btn--outlined': true,
                      active: elementTab === 'polls',
                    }"
                    data-entity="producer-assets-showPanels"
                    data-test="producer-assets-pollsTab"
                    @click="elementTab = 'polls'"
                  >
                    Polls
                  </button>

                  <button
                    :class="{
                      'tab-btn tab-btn--outlined': true,
                      active: elementTab === 'social displays',
                    }"
                    data-entity="producer-assets-showThemes"
                    data-test="producer-assets-displayTab"
                    @click="elementTab = 'social displays'"
                  >
                    Social
                  </button>

                  <button
                    v-if="elementTabOverflow && showElementTabOverFlowButton[1]"
                    class="small-viewport__button-right border-0 bg-transparent"
                    title="Scroll right"
                    data-entity="producer-assets-scrollRight"
                    data-test="producer-assets-elementTabs-scrollRight"
                    @click="scrollMenuRight"
                  >
                    <span class="fas fa-angle-right" />
                  </button>
                </div>
              </div>

              <div class="resource-library-body__list h-full min-h-0">
                <component
                  v-if="ready"
                  :key="elementTabComponent"
                  :is="elementTabComponent"
                  class="loaded"
                />
              </div>
            </div>

              <!-- Design Library -->
              <design-library v-else-if="libraryTab === 'design'" v-show="splitterHeights[0] > 0" />
            </div>
          </splitter-panel>
          <splitter-panel :min-height="40">
            <curated-content
              :collapsed="collapsedCurated"
              :ready="ready"
              :tagboard-id="tagboardId"
              @update:collapsed="collapsedCurated = $event"
              @update:tagboard-id="tagboardId = $event"
              @reload="reloadCuratedContent"
            />
          </splitter-panel>
      </splitter>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { defineAsyncComponent } from 'vue';

import GlobalSearch from '../../shared/GlobalSearch.vue';
import DesignLibrary from './DesignLibrary.vue';
import ShowList from './ShowList.vue';
import CuratedContent from './CuratedContent.vue';
import toast from '../../components/toast/toast';
import Splitter from '../../components/splitter/Splitter.vue';
import SplitterPanel from '../../components/splitter/SplitterPanel.vue';

export default {
  name: 'ResourceLibrary',
  props: {
    collapsed: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    GlobalSearch,
    DesignLibrary,
    ShowList,
    CuratedContent,
    Splitter,
    SplitterPanel,
  },

  data() {
    return {
      windowWidth: window.innerWidth,
      ready: false, // Necessary to make sure state is cleaned up before children load data
      collapsedElements: false,
      collapsedCurated: false,
      splitterHeights: [50, 50],
      libraryTab: 'content',
      libraryTabOverflow: false,
      showLibraryTabOverflowButton: [false, false],
      elementTab: 'graphics',
      elementTabOverflow: false,
      showElementTabOverFlowButton: [false, false],
      tagboardId: null,

      // TODO: Remove once flags are no longer needed
      useGlobalSearch: this.$ld.has('use-global-search-in-producer', false),
    };
  },

  computed: {
    ...mapState({
      panels: (state) => state.panels.panels,
      tagboards: (state) => state.tagboards.tagboards,
      templates: (state) => state.graphics.templates,
      themes: (state) => state.themes.themes,
    }),

    ...mapState('shoppable', [
      'selectedCollection',
    ]),

    production() {
      return this.$store.state.production.production;
    },

    hasPanels() {
      return this.$store.state.user.hasPanels;
    },

    elementTabComponent() {
      switch (this.elementTab) {
        case 'graphics':
          return defineAsyncComponent(() => import('./Graphics.vue'));
        case 'interactive':
          return defineAsyncComponent(() => import('./SmartPanels.vue'));
        case 'social displays':
          return defineAsyncComponent(() => import('./Themes.vue'));
        case 'polls':
          return defineAsyncComponent(() => import('./Polls/Tabs.vue'));

        default:
          return defineAsyncComponent(() => import('./Graphics.vue'));
      }
    },
  },

  watch: {
    collapsedCurated() {
      this.handleCollapse();
    },
    collapsedElements() {
      this.handleCollapse();
    },
    splitterHeights(v) {
      localStorage.producerLibrarySizes = JSON.stringify(v);
    },
  },

  mounted() {
    if (localStorage.producerLibrarySizes) {
      this.splitterHeights = JSON.parse(localStorage.producerLibrarySizes);

      // Keep the collapse toggle in sync with the shared splitter state
      // (curated maximized -> collapsed). Skipped for other ratios so a
      // custom drag size isn't overwritten by handleCollapse.
      if (this.splitterHeights[0] === 0) {
        this.collapsedCurated = true;
      }
    }

    this.handleTabOverflow(true, true, true);

    window.addEventListener('resize', this.handleResize);

    // If assets were already loaded before, then let's reset everything to empty.
    // This not only ensures assets to up-to-date,
    // but makes sure state is cleared if user is bouncing between teams.
    const hasAssets = (
      this.themes.length
      || this.templates.length
      || this.panels.length
      || this.tagboards.length
    );

    if (hasAssets) {
      this.resetAssetLibrary();
    }

    this.ready = true;
  },

  created() {
    this.$ld.on(this.onChangeFlags); // TODO: Remove
  },

  beforeUnmount() {
    this.$ld.off(this.onChangeFlags); // TODO: Remove
    window.removeEventListener('resize', this.handleResize);
  },

  methods: {
    ...mapActions([
      'getGraphics',
      'resetTemplates',
      'getTemplates',
      'getGraphicsTags',
      'resetThemes',
      'getThemes',
      'getSocialDisplayTags',
      'resetPanels',
      'getPanels',
      'getInteractiveTags',
      'resetTagboards',
      'clearTagboardPosts',
      'getPostsByTagboard',
      'getTagboardTags',
    ]),

    ...mapActions('shoppable', [
      'getProducts',
      'getCollections',
    ]),

    ...mapActions('polls', [
      'getPolls',
      'getPollTags',
      'resetPolls',
    ]),

    onChangeFlags() {
      const prev = this.useGlobalSearch;
      this.useGlobalSearch = this.$ld.has('use-global-search-in-producer', false);
      this.$nextTick(() => this.handleTabOverflow(false, true));

      // When global search is turned off, reload legacy asset library data
      if (prev && !this.useGlobalSearch) {
        this.reloadAssetLibrary();
      }
    },

    /**
    * Reset state for all assets to empty (and page back to 1).
    */
    resetAssetLibrary() {
      if (this.libraryTab === 'content') {
        this.$store.dispatch('resetTemplates');
        this.$store.dispatch('resetThemes');
        this.$store.dispatch('resetPanels');
        this.$store.dispatch('resetTagboards');
        this.resetPolls();

        // Reset currently active tagboard if it's open
        if (this.tagboardId) {
          this.$store.dispatch('clearTagboardPosts', this.tagboardId);
        }
      } else if (this.libraryTab === 'design') {
        this.$store.dispatch('assets/resetAssets');
      }
    },

    /**
    * Reload the Asset Library / Design Library section only.
    * Curated Content has its own refresh (see reloadCuratedContent).
    */
    async reloadAssetLibrary() {
      try {
        if (this.libraryTab === 'content') {
          if (this.useGlobalSearch) {
            this.$refs.globalSearch?.refresh();
          } else {
            this.$store.dispatch('resetTemplates');
            this.$store.dispatch('resetThemes');
            this.$store.dispatch('resetPanels');
            this.resetPolls();

            await Promise.all([
              this.$store.dispatch('getTemplates'),
              this.getGraphicsTags(),
              this.$store.dispatch('getThemes'),
              this.getSocialDisplayTags(),
              this.$store.dispatch('getPanels'),
              this.getInteractiveTags(),
              this.getPolls(),
              this.getPollTags(),
            ]);
          }
        } else if (this.libraryTab === 'design') {
          this.$store.dispatch('assets/resetAssets');
          await this.$store.dispatch('assets/getAssets');
        }

        // The Shows tab doesn't have its own reload button; refresh it here
        // too whenever the header refresh is clicked. No-op when the Shows
        // tab isn't mounted (it refetches on mount anyway).
        this.$refs.showList?.reload();

      } catch (err) {
        console.error('Failed to reload asset library:', err);

        toast.makeToast({
          heading: 'Error',
          icon: 'error',
          loaderBg: 'red',
          text: 'Error reloading asset library. Some or all assets might not have loaded properly.',
        });
      }
    },

    async reloadCuratedContent() {
      try {
        this.$store.dispatch('resetTagboards');

        if (this.tagboardId) {
          this.$store.dispatch('clearTagboardPosts', this.tagboardId);
        }

        await Promise.all([
          this.$store.dispatch('getTagboards'),
          this.getTagboardTags(),
          (this.selectedCollection && this.selectedCollection > 0)
            ? this.getProducts({ reset: true, collectionId: this.selectedCollection })
            : this.getCollections({ reset: true }),
          this.tagboardId
            ? this.$store.dispatch('getPostsByTagboard', { tagboardId: this.tagboardId })
            : null,
        ]);
      } catch (err) {
        console.error('Failed to reload curated content:', err);

        toast.makeToast({
          heading: 'Error',
          icon: 'error',
          loaderBg: 'red',
          text: 'Error reloading curated content. Some sections might not have loaded properly.',
        });
      }
    },

    scrollMenuLeft(e) {
      const menuContainer = e.target.closest('.source-types');
      menuContainer.scrollLeft -= 150; // Adjust this value as needed
    },

    scrollMenuRight(e) {
      const menuContainer = e.target.closest('.source-types');
      menuContainer.scrollLeft += 150; // Adjust this value as needed
    },

    handleScroll(el) {
      this.handleTabOverflow(el === 'elementTabs', el === 'libraryTabs');
    },

    handleTabOverflow(checkElTabs = false, checkLibraryTabs = false) {
      const { elementTabs, libraryTabs } = this.$refs;

      if (checkLibraryTabs && libraryTabs) {
        this.libraryTabOverflow = libraryTabs.scrollWidth > libraryTabs.clientWidth;
        this.showLibraryTabOverflowButton = [
          libraryTabs.scrollLeft !== 0,
          libraryTabs.scrollLeft < libraryTabs.scrollWidth - libraryTabs.clientWidth,
        ];
      }

      if (checkElTabs && elementTabs) {
        this.elementTabOverflow = elementTabs.scrollWidth > elementTabs.clientWidth;
        this.showElementTabOverFlowButton = [
          elementTabs.scrollLeft !== 0,
          elementTabs.scrollLeft < elementTabs.scrollWidth - elementTabs.clientWidth,
        ];
      }
    },

    handleResize() {
      this.windowWidth = window.innerWidth;
      this.handleTabOverflow(true, true, true);
    },

    handleCollapse() {
      if (this.collapsedElements && this.collapsedCurated) {
        this.splitterHeights = [50, 50];
      } else if (this.collapsedCurated) {
        this.splitterHeights = [0, 100];
      } else if (this.collapsedElements) {
        this.splitterHeights = [100, 0];
      } else {
        this.splitterHeights = [50, 50];
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.source-types-wrapper {
  min-height: 0;
  position: relative;
  background: #222222;
}

.small-viewport {
  overflow-x: auto;
  scrollbar-width: none;
  overscroll-behavior: contain auto;

  span:first-child {
    padding-left: 0.75rem;
  }

  span{
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  &__button-right, &__button-left {
    position: absolute;
    line-height: 2.5rem;
    padding: 0 0.625rem;
    border: none;
    border-radius: 0;

    &:focus {
      outline: none;
    }

    span {
      border-bottom: none;
    }
  }

  &__button-right {
    right: 0;
    background: linear-gradient(-90deg, #1e1e1e 75%, transparent);
  }
  &__button-left {
    left: 0;
    background: linear-gradient(-90deg, transparent, #1e1e1e 25%);
  }
}
</style>
